var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod-extra-validate clearfix",style:(_vm.fullStyle)},[_c('div',{staticClass:"validate-box-container"},[_c('div',{staticClass:"validate-box clearfix"},[_c('div',{staticClass:"head"},[_vm._v("自选产品购买")]),_c('div',{staticClass:"content"},[_c('add-passenger',{ref:"verify",on:{"subbmit":_vm.handleOk}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }